import axios from 'axios';
import { API_BASE_URL } from '../config';

console.log('[AXIOS_TS] Received API_BASE_URL:', API_BASE_URL);
console.log('[AXIOS_TS] Environment Variables:', import.meta.env);

// Create axios instance with base URL
const api = axios.create({
    baseURL: API_BASE_URL,
});

// Add request interceptor for debugging only
api.interceptors.request.use(request => {
    // Add auth token if available
    const token = localStorage.getItem('token');
    if (token) {
        request.headers.Authorization = `Bearer ${token}`;
    }

    // Ensure URL is using HTTPS except for localhost
    const fullUrl = new URL(
        request.url || '',
        request.baseURL || API_BASE_URL
    ).toString();
    
    if (fullUrl.startsWith('http://') && !fullUrl.includes('localhost')) {
        request.url = fullUrl.replace('http://', 'https://');
    }
    
    // Debug log for form data
    let debugData = request.data;
    if (request.data instanceof URLSearchParams) {
        debugData = Object.fromEntries(request.data);
    }
    
    console.log('[AXIOS_INTERCEPTOR] Request details:', {
        originalBaseURL: API_BASE_URL,
        configuredBaseURL: request.baseURL,
        fullURL: fullUrl,
        method: request.method,
        headers: request.headers,
        path: request.url,
        baseURL: request.baseURL,
        environment: import.meta.env.MODE,
        data: debugData,
        params: request.params,
        dataType: request.data ? request.data.constructor.name : null
    });

    return request;
}, error => {
    return Promise.reject(error);
});

// Add response interceptor for error handling
api.interceptors.response.use(
    response => response,
    error => {
        const status = error.response?.status;
        const details = {
            status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            method: error.config?.method,
            path: error.config?.url,
        };

        if (status === 401 || status === 403) {
            console.warn('[AXIOS_INTERCEPTOR] Auth error:', details);
        } else {
            console.log('[AXIOS_INTERCEPTOR] Error details:', details);
        }
        return Promise.reject(error);
    }
);

export default api;
